import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao-pagamento');

const configuracaoPagamentoActions = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
  pesquisarSap: { method: 'GET', url: `${basePath}/chave/SAP_AUTOMATICO` },
  verificar: { method: 'GET', url: `${basePath}/habilitado?chave={chave}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoPagamentoActions);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-pagamento.js